<template>
	<div class="container" :class="isOpen ? '' : 'not-expanded'">
		<div class="header" @click="$emit('toggle')">
			<h4>{{ header }}</h4>
			<font-awesome-icon class="expand-icon" :icon="isOpen ? 'fa-minus' : 'fa-plus'" size="1x" />
		</div>
		<div class="content-wrapper">
			<div class="collapse-content">
				<div class="content">
					<wysiwyg-content :content="content" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
defineProps<{
	header: string;
	content: string;
	isOpen?: boolean;
}>();

defineEmits(['toggle']);
</script>

<style lang="scss" scoped>
.content-wrapper {
	display: grid;
	grid-template-rows: 1fr;
	transition: grid-template-rows 0.4s ease;

	.not-expanded & {
		grid-template-rows: 0fr;
	}
}

.header,
.content {
	font-size: 15px;
	padding: 20px;
	width: 100%;
	border-bottom: 1px solid #f1f1f1;
}

.container {
	text-align: left;

	.header {
		cursor: pointer;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;

		&::before {
			content: '';
			display: block;
			position: absolute;
			left: 0;
			top: 0;
			bottom: -1px;
			width: 10px;
			background-color: var(--cta-color);
		}

		.expand-icon {
			color: var(--dark-background-color);
			font-size: 1.2em;
		}

		h4 {
			margin-bottom: 0;
			padding-left: 15px;
			font-size: 1.2em;
		}
	}

	.collapse-content {
		overflow: hidden;
	}

	.content {
		padding: 20px;
		border-top: none;

		ul,
		ol {
			padding: 0 0 0 20px;
		}

		:deep(:first-child) {
			margin-top: 0;
		}

		:deep(:last-child) {
			margin-bottom: 0;
		}
	}
}
</style>
